module.exports = __webpack_public_path__ + "static/media/wallet.0bd82d87.svg";